import React from 'react';
import SalesmanPrice from './SalesmanPrice';
import ContentView from '../../Layouts/ContentView';
const index = () => {
    return (
        <ContentView>
            <SalesmanPrice />
        </ContentView>
    );
};
export default index;
